export default {
    data () {
        return {
            globalFileAccept: 'image/*, application/pdf',
            maxFileSize: 10,
        }
    },

    methods: {
        /**
         * Validate File
         *
         * @param currentElementID     input element ID
         * @param file                 HTML File object
         * @returns {boolean}
         */
        validateFile (currentElementID, file) {
            let proceedFileChange = true;

            // validate file size
            if((file.size / 1024 / 1024) > this.maxFileSize){
                alert("Selected file size must be less than 10MB");
                proceedFileChange = false;
                return false;
            }

            // check for file duplicates
            $('input[type="file"]:not(input#'+ currentElementID + ')').each((index, field) => {
                if (field.files.length > 0) {
                    const field_file = field.files[0];
                    if (field_file.name === file.name) {

                        if(confirm("Duplicate file found, you have uploaded this file before. Proceed?")) {
                            this.proceedFileChange = true;
                            return false;
                        }  else {
                            this.proceedFileChange = false;
                            return false;
                        }
                    }
                }
            });

            return proceedFileChange;
        },
    }
}